// eslint-disable-next-line import/no-unresolved
import './components'
import './extends'



// WEBPACK FOOTER //
// ./src/js/components/validate/validate.js